import React from "react"
import axios from "axios";
import { setup as URI_SETUP } from "../../../../config/api";
//import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';

const uri_catalogs = URI_SETUP+"catalog";

/*
const SortableItem = SortableElement(({value}) =>
  <li>{value}</li>
);

const SortableList = SortableContainer(({items}) => {
  return (
    <ul>
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value} />
      ))}
    </ul>
  );
});
*/

class CorporativeCatalogs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            catalog_listing                 : [],
            depend_of_catalogs              : [],
            //items                           : ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5', 'Item 6'],
            selected_catalog                : { 
                                                _id : "" , 
                                                id : "" , 
                                                name : ""
                                            },
            catalog_item                    : {
                                                _id         : "",
                                                name        : ""
                                            },
            status_catalog_listing          : "hide",
            status_catalog_item_modal       : "hide",
            catalog_item_action             : "new",
            status_catalog_category_modal   : "hide",
            catalog_category_action         : "new",
            background_filter               : "",
            status_confirm_item_deletion    : "hide",
            }
    }

    componentWillMount(){
    }

    // ----------------------- Handlers -----------------------

    handleCatalogSelector(catalog) {
        let self = this;
        self.setState({ depend_of_catalogs : [] }) 
        
        if(catalog.depends_of != undefined){
            Object.keys(catalog.depends_of).map((key, index) => {

                axios.get(uri_catalogs+"/"+catalog.depends_of[key].id, { 
                    params: {
                        api_token   : localStorage.getItem("api_token"),
                        mode        : "imported_free"
                    }
                }).then(request => {

                    let catalog_item = Object.assign({}, self.state.catalog_item);
                    catalog_item[catalog.depends_of[key].id] = request.data[0]._id.$oid;
                    self.setState({catalog_item});

                    self.setState({ 
                        
                    depend_of_catalogs : 
                                    {
                                        [key] : {
                                        _id         : catalog.depends_of[key]._id,
                                        id          : catalog.depends_of[key].id,
                                        value       : "",
                                        list        : request.data
                                    }
                                }
                    })
                    
                })

            })
            
        }

        axios.get(uri_catalogs+"/"+catalog.id, { 
            params: {
                api_token   : localStorage.getItem("api_token"),
                mode        : 'edit'
            }
        }).then(request => { 
            self.setState({ 
            catalog_listing          : request.data,
            selected_catalog         : catalog,
            status_catalog_listing   : ""
            }) 
        })
    }

    handleEditCatalogItem(catalogItem) {
        let self = this;
        self.setState({ 
            status_catalog_item_modal      : "",
            background_filter              : "blur",
            catalog_item_action            : "edit",
            catalog_item                   : catalogItem
            })
    }

    handleNewCatalogItem() {
        let self = this;
        self.clearCatalogItem();
        self.setState({ 
            status_catalog_item_modal      : "",
            background_filter              : "blur",
            catalog_item_action            : "new"
            })
    }

    handleNewCatalogCategory() {
        let self = this;
        self.clearCatalogItem();
        self.setState({ 
            status_catalog_category_modal          : "",
            background_filter                      : "blur",
            catalog_category_action                : "new"
            })
    }

    handleCatalogItemChange = (e) => {
        let catalog_item = Object.assign({}, this.state.catalog_item);
        catalog_item[e.target.name] = e.target.value;
        this.setState({catalog_item});
    }

    handleDependenceChange = (e) => {
        let catalog_item = Object.assign({}, this.state.catalog_item);
        catalog_item[e.target.attributes.getNamedItem('data-key').value] = e.target.value;
        this.setState({catalog_item});
    }

    handleCatalogItemSelector(item,action) {
        let self = this;
        var qs = require("qs");
        const itemToSent = qs.stringify({
            property_id     : self.props.hotel_selected,
            action          : action
        });
        

        axios.post(uri_catalogs+"/"+self.state.selected_catalog.id+"/"+item, itemToSent)
        .then(request => { 
            self.handleCatalogSelector(self.state.selected_catalog);
            self.setState({ 
                catalog_items_found    : []
                }) 
        })   
        

    }

    // ----------------------- Functions -----------------------

    /*
    onSortEnd = ({oldIndex, newIndex}) => {
        this.setState({
          items: arrayMove(this.state.items, oldIndex, newIndex),
        });
    };
    */
    cancelCatalogItem(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_catalog_item_modal    : "hide",
            background_filter            : ""
            })
    }

    cancelCatalogCategory(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_catalog_category_modal    : "hide",
            background_filter                : ""
            })
    }

    clearCatalogItem(){
        let self = this;
        let catalog_item = Object.assign({}, self.state.catalog_item);
        catalog_item["_id"]="";
        catalog_item["name"]="";
        self.setState({catalog_item});
    }

    onSubmitCatalogItem(e){
        let self = this;
        e.preventDefault();
        var qs = require("qs");
        const catalogItemToSent = qs.stringify(self.state.catalog_item);

        if(self.state.catalog_item_action=="new"){
            axios.post(uri_catalogs+"/"+self.state.selected_catalog.id, catalogItemToSent)
                    .then(request => { 
                        //console.log(request);
                    })  
        }else{
            axios.post(uri_catalogs+"/"+self.state.selected_catalog.id+"/"+self.state.catalog_item._id.$oid, catalogItemToSent)
            .then(request => { 
                //console.log(request);
            })   

        }

        self.handleCatalogSelector(self.state.selected_catalog);
        self.setState({ 
            status_catalog_item_modal      : "hide",
            background_filter              : ""
            })
        
    }

    openConfirmItemDeletion(item){
        let self = this;
        self.setState({ 
            catalog_item                    : item,
            status_confirm_item_deletion    : "",
            background_filter               : "blur"
            })
    }

    cancelConfirmItemDeletion(e){
        let self = this;
        e.preventDefault();
        self.setState({ 
            status_confirm_item_deletion    : "hide",
            background_filter       : ""
            })
    }

    confirmItemDeletion(e) {
        let self = this;
        var qs = require("qs");
        e.preventDefault();
        const itemToSent = qs.stringify({});

        axios.post(uri_catalogs+"/"+this.state.selected_catalog.id+"/"+this.state.catalog_item._id.$oid+"/destroy", itemToSent)
                .then(request => {
                    self.handleCatalogSelector(self.state.selected_catalog);
                    self.setState({     
                        status_confirm_item_deletion        : "hide",
                        background_filter                   : ""
                    }) 
            })
    }

    // ----------------------- Renders -----------------------

    renderCatalogs() {
        let self = this;
        return <ul>
                    {   
                        this.props.catalogs.map(function(catalog, i) {
                            if(catalog.type.indexOf("general")>=0){
                                return (<li  key={i}  >
                                    <div  className={(catalog.id==self.state.selected_catalog.id)?"selected":""}>{catalog.name.en}
                                        <i className="fa fa-plus-circle edit clickable" onClick={self.handleCatalogSelector.bind(self, catalog)}></i> 
                                        {!catalog.default  &&
                                            <i className="fa fa-edit edit clickable"></i> 
                                        }
                                    </div>
                                </li>);
                                }
                            })
                    }
                </ul>   
    }

    renderCatalogItems() {
        return  <ul>
                    <li className="list-header"><div className="label">{this.state.selected_catalog.en} </div></li>
                    {Object.keys(this.state.catalog_listing).map((key, index) => {
                        if (this.state.catalog_listing[key].property==undefined){
                            return (<li key={this.state.catalog_listing[key]._id.$oid} >
                                    <div>{this.state.catalog_listing[key].name}
                                        <i className="fa fa-times-circle remove clickable" onClick={this.openConfirmItemDeletion.bind(this, this.state.catalog_listing[key])} ></i> 
                                        <i className="fa fa-edit edit clickable" onClick={this.handleEditCatalogItem.bind(this,this.state.catalog_listing[key])}></i>
                                    </div>
                                </li>);
                        }else{
                            return (<li key={this.state.catalog_listing[key]._id.$oid} className="no-general" >
                                <div>{this.state.catalog_listing[key].name}
                                    <i className="fa fa-times-circle remove clickable" onClick={this.openConfirmItemDeletion.bind(this, this.state.catalog_listing[key])} ></i> 
                                    <i className="fa fa-edit edit clickable" onClick={this.handleEditCatalogItem.bind(this,this.state.catalog_listing[key])}></i>
                                    <i className="fa fa-plus-circle edit clickable" onClick={this.handleCatalogItemSelector.bind(this, this.state.catalog_listing[key]._id.$oid,'become-general')}></i>
                                </div>
                            </li>);
                        }
                    })
                    }
                </ul>   
    }

    renderDependsOfSelects() {
        if(this.state.depend_of_catalogs!=[]){
            return Object.keys(this.state.depend_of_catalogs).map((key, index) => {
                    return ( <div key={index} className="col col-md-12">
                                <select className="form-control" name={ this.state.depend_of_catalogs[key].id } 
                                        onChange={e => this.handleDependenceChange(e)}
                                        data-key={this.state.depend_of_catalogs[key].id} 
                                        value={ (this.state.catalog_item[this.state.depend_of_catalogs[key].id]!=undefined)?
                                        this.state.catalog_item[this.state.depend_of_catalogs[key].id] : ""}  
                                    >
                                    { Object.keys(this.state.depend_of_catalogs[key].list).map((key_list, index) => {
                                            if (!this.state.depend_of_catalogs[key].list[key_list].imported){
                                                return( <option key={index} value={this.state.depend_of_catalogs[key].list[key_list]._id.$oid} >
                                                    {this.state.depend_of_catalogs[key].list[key_list].name}
                                                </option>);
                                            }
                                        })
                                    }
                                </select>   
                            </div>
                            );
                    });
        }  
    }

    renderCatalogItemModal() {
        return <div className="box regular col-md-4 ">
                    <h3>{this.state.catalog_item_action=="new"? "NEW CATALOG ITEM": "EDIT CATALOG ITEM" } <i className="fa fa-times-circle" onClick={this.cancelCatalogItem.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="catalog_item_form" onSubmit={this.onSubmitCatalogItem.bind(this)}>
                            <input type="hidden" name="catalog_item" value={(this.state.catalog_item._id.$oid==null)? "": this.state.catalog_item._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label htmlFor="name">{this.state.catalog_item_action=="new"? "Add new catalog item": "Edit catalog item" }</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.catalog_item.name==null)? "": this.state.catalog_item.name} required onChange={e => this.handleCatalogItemChange(e)}  />          
                                </div>
                                { this.renderDependsOfSelects() }

                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelCatalogItem.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">SAVE</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderCatalogCategoryModal() {
        return <div className="box regular col-md-4 ">
                    <h3>{this.state.catalog_item_action=="new"? "NEW CATALOG CATEGORY": "EDIT CATALOG CATEGORY" } <i className="fa fa-times-circle" onClick={this.cancelCatalogCategory.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="catalog_item_form" onSubmit={this.onSubmitCatalogItem.bind(this)}>
                            <input type="hidden" name="catalog_item" value={(this.state.catalog_item._id.$oid==null)? "": this.state.catalog_item._id.$oid} /> 
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <label htmlFor="name">{this.state.catalog_category_action=="new"? "Add new catalog category": "Edit catalog category" }</label>
                                    <input type="text" className="form-control" name="name" placeholder="Name" value={(this.state.selected_catalog.name==null)? "": this.state.catalog_item.name} required onChange={e => this.handleCatalogItemChange(e)}  />          
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelCatalogCategory.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">SAVE</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    renderConfirmItemDeletion() {
        return <div className="box notifications col-md-4 ">
                    <h3>NOTIFICATION <i className="fa fa-times-circle" onClick={this.cancelConfirmItemDeletion.bind(this)} ></i> </h3>
                    <div className="form-in-box">
                        <form id="brand_form" onSubmit={this.confirmItemDeletion.bind(this)}>
                            <div className="form-row">
                                <div className="col col-md-12">
                                    <h4>Are you sure to continue?</h4>
                                    <p>By confirming this proccess you accept to remove all the dependences for this catalog value, any information related to it need to be reasigned</p>
                                </div>
                                <div className="form-row">
                                    <div className="col col-md-6">
                                        <button onClick={this.cancelConfirmItemDeletion.bind(this)}>CANCEL</button>   
                                    </div>
                                    <div className="col col-md-6">
                                        <button type="submit" className="blue">CONFIRM</button> 
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

    }

    render() {
        return (
            <section>
                <div className={this.state.background_filter}>
                    <div className="head-content "> 
                        <div className="icon col-md-2 px-2">
                            <h1>Setup</h1>
                            <h2>Corporate Information</h2>
                        </div>
                        <div className="col-md-8 px-2">    
                            
                            <div className="description">
                                <p className="desc-no-icon"><strong>Create Corporative catalogs by telling Magnum Leap the KPIs that you want the system to analyze.</strong> <br/> These KPIs can be anything you choose – agencies, plan types, etc. This data will be the KPIs that Magnum Leap will use to measure your corporate regions and brands.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 no-padding"> 
                        <div className="box regular col-md-3">
                            <h3>KIND OF DATA</h3>
                            <div className="list-in-box">
                                <ul>
                                    <li><div>PMS <i className="fa fa-plus-circle remove"></i></div></li>
                                </ul>
                            </div>
                        </div>
                        <div className="box regular col-md-4">
                            <h3>CATALOG</h3>
                            <div className="list-in-box">
                                {this.renderCatalogs()}
                                <button className="blue" onClick={this.handleNewCatalogCategory.bind(this)}>NEW +</button>
                            </div>
                        </div>
                        <div className={"box regular col-md-5 " + this.state.status_catalog_listing}>
                            <h3>CATALOG LIST</h3>
                            <div className="list-in-box">
                                {this.renderCatalogItems()}
                                <button className="blue" onClick={this.handleNewCatalogItem.bind(this)}>NEW +</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={"modal " + this.state.status_catalog_item_modal}> 
                    {this.renderCatalogItemModal()}
                </div>
                <div className={"modal " + this.state.status_catalog_category_modal}> 
                    {this.renderCatalogCategoryModal()}
                </div>
                <div className={"modal " + this.state.status_confirm_item_deletion}> 
                    {this.renderConfirmItemDeletion()}
                </div>

            </section>
        )
    }

}

export default CorporativeCatalogs


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/views/corporative/CorporativeCatalogs.js